import { render, staticRenderFns } from "./setupMfa.vue?vue&type=template&id=5b92752a"
import script from "./setupMfa.vue?vue&type=script&lang=js"
export * from "./setupMfa.vue?vue&type=script&lang=js"
import style0 from "./setupMfa.vue?vue&type=style&index=0&id=5b92752a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports